import {Navigate, useLocation} from 'react-router'

// Legacy /school/* links → /institute/*. Replaces the history entry (or Back
// lands here and redirects forward again) and keeps the query string so deep
// links (grid page, sort, search, filters) survive.
const SchoolToInstitute = () => {
  const location = useLocation()

  return (
    <Navigate
      replace
      to={{
        pathname: location.pathname.startsWith('/school/')
          ? location.pathname.replace('/school/', '/institute/')
          : location.pathname,
        search: location.search,
        hash: location.hash,
      }}
    />
  )
}

export default SchoolToInstitute
